import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { MapComponent } from "../components/map/MapComponent";
import { FundListComponent } from "../components/FundListComponent";
import { LoadingComponent } from "jsl-ui";
import { ImageGallerieComponent } from "../components/image-gallerie/ImageGallerieComponent";
import { PublicController } from "../../ajax/PublicController";
import { TaxaDTO } from "../../ajax/types/TaxaDTO";
import { isInRole } from "../../helper/ajax";
import { UploadImageToTaxonComponent } from "../components/UploadImageToTaxonComponent";

// const $ = (window as any).$;

export class TaxonComponent implements IJSLComponent {

    private data: TaxaDTO;

    private map: MapComponent;

    private fundListe: FundListComponent;

    private uploadImagetoTaxon: UploadImageToTaxonComponent;

    constructor(private id: number) {
        PublicController.GetTaxon({id}).then((data) => {
            this.data = data;
            this.map = new MapComponent(data.markers.map(x => ({lat: x.lat, lon: x.lon, verschleiert: data.koordinatenVerschleiert})));
            refresh();
        });
        if (isInRole("admin")) {
            this.uploadImagetoTaxon = new UploadImageToTaxonComponent(id);
        }
        // $.getJSON("/api/public/getTaxon/" + id, (data, status, xhr) => {
        //     this.data = data;
        //     this.map = new MapComponent(data.markers);
        //     refresh();
        // });,
    }

    public render(): IJSLVNode {
        return <section class="banner-area">
            {this.data != null ?
                <div class="col-md-12" style="text-align:center">
                    <div style="text-align:left;"><a class="genric-btn primary" href="#">zurück</a></div>
                    <h3>Taxon Daten</h3>
                    <div style="font-weight:bold;">Name: {this.data.name}</div>
                    {/* <div>Name (kurz): {this.data.kurzerName}</div> */}
                    <table class="info-table">
                        <tr>
                            <td>Systematik: </td><td>{this.data.phylum} - {this.data.ordnung} - {this.data.familie}</td>
                        </tr>
                        <tr>
                            <td>Autor: </td><td>{this.data.autor}</td>
                        </tr>
                        <tr>
                            <td>Deutscher Name: </td><td>{this.data.deutscherName}</td>
                        </tr>
                        <tr>
                            <td>Substrat: </td><td>{this.data.substratTaxa}</td>
                        </tr>
                        <tr>
                            <td>Rote Liste: </td><td>{this.data.roteListeOesterreich ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Lebensweise: </td><td>{this.data.lebensweise ?? "-"}</td>
                        </tr>
                    </table>
                    {new ImageGallerieComponent(this.data.images, 11)}
                    {this.uploadImagetoTaxon}
                    <div>Funde in Datenbank: <span style="font-weight:bold">{this.data.anzahlFunde}</span></div>
                    <div><button class="genric-btn default-border" style="margin-left:0.5rem" click={this.toggleFunde}>{this.fundListe != null ? "Funde ausblenden" : "Funde anzeigen"}</button></div>
                    {this.fundListe ?? { tag: "p", content: "&nbsp;", raw: true }}
                    <h3>Karte</h3>
                    <div>
                        {this.data.koordinatenVerschleiert ? <p><i>ACHTUNG: die Fundkoordinaten wurden als sensibel eingestuft und werden mit einer Unschärfe von bis zu 50km angezeigt</i></p> : undefined}
                    </div>
                    {this.data.distinctFundorte > this.data.markers.length ?
                        <div style="font-style:italic;">Anmerkung: Es gibt zu viele Funde um alle auf der Karte darzustellen</div> : null}
                    {this.map}
                    <p>&nbsp;</p>
                </div> : new LoadingComponent().render()}</section>;
    }

    private toggleFunde(): void {
        if (this.fundListe == null) {
            this.fundListe = new FundListComponent(PublicController.GetFunde({ id: this.id }));
        } else {
            this.fundListe = null;
        }
    }
}
